import React from 'react';
import { useHistory } from 'react-router';
import Header from './Header';
import {
  StyledControlsWrapper,
  StyledBackButton,
  StyledControls,
} from './ControlsStyledComponents';

interface IControlsProps {
  title: string;
  description: string;
  logo?: string;
  showHeader?: boolean;
  bottomOffset?: number;
  idle?: boolean;
  darkOverlay?: boolean;
}

const Contrors: React.FC<IControlsProps> = (props) => {
  const {
    title,
    description,
    logo,
    showHeader = true,
    bottomOffset,
    darkOverlay,
    idle,
    children,
  } = props;
  const history = useHistory();

  return (
    <StyledControlsWrapper darkOverlay={darkOverlay}>
      <StyledBackButton idle={idle} onEnter={history.goBack} />
      {showHeader && <Header title={title} description={description} logo={logo} idle={idle} />}
      <StyledControls isSeriesPlayer={false} bottomOffset={bottomOffset} idle={idle}>
        {children}
      </StyledControls>
    </StyledControlsWrapper>
  );
};

export default Contrors;
